<!--
 * @Author: your name
 * @Date: 2021-08-10 01:28:02
 * @LastEditTime: 2022-03-14 22:37:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/views/Hint.vue
-->
<template>
  <div class="basic-container">
    <OuterRing class="outer-ring">
      <span slot="title" class="title"> 基本信息（参检孕妇） </span>
      <van-form label-width="6.6em" label-align="right" colon>
        <van-field
          v-model="form.name"
          label="姓名"
          placeholder="请输入姓名"
          readonly
          :rules="[
            { required: true },
            {
              pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\·]{2,15}$/,
              message: '姓名需为2~15个中文字符',
            },
          ]"
        />

        <Provinces
          ref="FormWithProvinces"
          @form-with-provinces="FormWithProvincesCall"
          :form="form"
        ></Provinces>

        <van-field
          v-model="form.mobile"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[
            { required: true },
            {
              pattern: /^[\d]{11}$/,
              message: '手机号格式不正确',
            },
          ]"
        />
        <van-field
          v-model="form.idStr"
          label="身份证号"
          placeholder="请输入身份证号码"
          readonly
          :rules="[
            { required: true },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: '身份证号格式不正确',
            },
          ]"
          @blur="checkUserInfo"
        />
        <van-field
          v-model="form.hospitalName"
          label="无创检测医院"
          placeholder="请输入无创检测医院全称"
          :rules="[
            { required: true },
            {
              pattern: /^[\u4e00-\u9fa5-a-zA-Z-\d]{4,30}$/,
              message: '医院名称需为4~30个字符',
            },
          ]"
        />

        <van-field
          v-model="form.amniocentesisHospital"
          :label="isHighRisk ? '羊水穿刺医院' : '诊断医院'"
          readonly
          :placeholder="isHighRisk ? '请选择羊水穿刺医院' : '请选择诊断医院'"
          :rules="[{ required: true }]"
          @click="openHospital"
        />

        <van-popup
          v-model="showHospital"
          round
          :close-on-click-overlay="false"
          position="bottom"
          closeable
          :style="{ height: '70%' }"
        >
          <div class="popup-container">
            <div class="popup-header">
              <van-search
                v-model="popup.search"
                background="#fff"
                shape="round"
                placeholder="请输入医院名称"
                @input="getHospitals"
                class="popup-search"
              />
            </div>
            <div class="popup-content">
              <van-radio-group v-model="form.amniocentesisHospitalCode">
                <van-cell-group>
                  <template v-if="hospitalList.length">
                    <van-cell
                      :title="item.name"
                      v-for="item of hospitalList"
                      :key="item.key"
                      clickable
                      @click="form.amniocentesisHospitalCode = item.code"
                    >
                      <div slot="label">
                        <template
                          v-if="item.alais_name && item.alais_name !== item.name"
                        >
                          <p>别名：{{ item.alais_name }}</p>
                        </template>
                        <p>地址：{{ item.region }}</p>
                      </div>
                      <template #right-icon>
                        <van-radio
                          :name="item.code"
                          shape="square"
                          checked-color="#1989fa"
                        />
                      </template>
                    </van-cell>
                  </template>
                  <van-empty v-else image="search">
                    <div slot="description">
                      <p class="popup-description-black">
                        请输入{{!popup.search ? "" : "更多"}}医院关键字进行查询
                      </p>
                      <p class="popup-description-orange">
                        如果没有找到您的{{isHighRisk ? '羊水穿刺' : '诊断'}}医院，请在公众号中留言
                      </p>
                    </div>
                  </van-empty>
                </van-cell-group>
              </van-radio-group>
            </div>
            <div class="popup-footer">
              <van-button type="info" @click="checked">完 成</van-button>
            </div>
          </div>
        </van-popup>

        <van-field
          v-if="isHighRisk"
          readonly
          clickable
          name="picker"
          :value="amniocentesis"
          label="羊水穿刺结果"
          placeholder="点击选择"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom" round>
          <van-picker
            show-toolbar
            value-key="value"
            :columns="amniocentesisOption"
            @confirm="checkAmniocentesis"
            @cancel="showPicker = false"
          />
        </van-popup>
      </van-form>
      <UploadSubmit
        v-if="$route.query.upload"
        :upload="onSubmit"
        :serNo="serNo"
      ></UploadSubmit>
      <div v-else class="operate">
        <van-button type="info" @click="onSubmit">下一步</van-button>
      </div>
    </OuterRing>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
const amniocentesisOption = [
  { value: "高风险-(阳性)", id: "1" },
  { value: "低风险-(阴性)", id: "5" },
];

import UploadSubmit from "./UploadSubmit";
export default {
  name: "UploadBasic",
  components: {
    UploadSubmit,
  },
  data() {
    return {
      showPicker: false,
      amniocentesisOption: amniocentesisOption,
      amniocentesis: "",
      form: {
        t: this.$route.params.t,
        name: "",
        mobile: "", //手机号
        idStr: "", //身份证号
        hospitalName: "", // 医院名称
        amniocentesis: "", // 羊水穿刺id
        // TODO: 字段待确认
        amniocentesisHospital: "", // 羊水穿刺医院
        amniocentesisHospitalCode: "",
      },
      popup: {
        search: "",
        hospitalListBack: [],
      },
      hospitalList: [],
      showHospital: false,
      // 省市区
      areaAllName: "",
      isInit: false,
      serNo: "",
    };
  },
  computed: {
    isHighRisk() {
      return this.$route.params.t === "10";
    },
  },
  created() {
    this.initData();
  },
  methods: {
    openHospital() {
      if (this.form.amniocentesisHospital) {
        this.popup.search = this.form.amniocentesisHospital;
      }

      this.getHospitals();
      this.showHospital = true;
    },
    checked() {
      if (!this.form.amniocentesisHospitalCode) {
        return Toast.fail("请选择羊水穿刺医院");
      }
      this.popup.hospitalListBack = this.hospitalList;

      const result = this.hospitalList.find(
        (item) => item.code === this.form.amniocentesisHospitalCode
      );

      if (!result) {
        return Toast.fail("请选择要修改的羊水穿刺医院");
      }

      this.form.amniocentesisHospital = result.name;
      this.form.amniocentesisHospitalCode = result.code;

      this.showHospital = false;

      this.hospitalList = [];
    },
    async getHospitals() {
      const { data } = await this.$api.common.getHospitals(this.popup.search);

      this.hospitalList = data;
    },
    checkAmniocentesis(value) {
      this.amniocentesis = value.value;
      this.form.amniocentesis = value.id;
      this.showPicker = false;
    },
    FormWithProvincesCall(areaAllName) {
      this.areaAllName = areaAllName;
    },
    async onSubmit() {
      const dataWithProvinces = this.$refs.FormWithProvinces.verify();
      try {
        if (!this.form.name) {
          throw "请输入参检孕妇的姓名";
        }
        if (!dataWithProvinces) {
          throw "请选择省市区";
        }
        if (!this.form.mobile) {
          throw "请输入参检孕妇的手机号";
        }
        if (!this.form.idStr) {
          throw "请输入参检孕妇的身份证号码";
        }
        if (!this.form.hospitalName) {
          throw "请输入参检孕妇的无创检测医院全称";
        }
        if (!this.form.amniocentesisHospitalCode) {
          if(this.isHighRisk){
            throw "请选择羊水穿刺医院";
          }else{
            throw "请选择诊断医院";
          }
        }
        if (this.isHighRisk && !this.form.amniocentesis) {
          throw "请选择羊水穿刺";
        }
      } catch (error) {
        Toast.fail(error);
        return Promise.reject();
      }

      let baseData = null;

      try {
        const strJsonBaseData = window.sessionStorage.getItem("baseData");

        baseData = JSON.parse(strJsonBaseData);

        if (baseData === null) baseData = {};
      } catch (error) {
        await Dialog.alert({
          title: "信息缺失提示",
          message: "没有查到您的保单信息，请先检索您的保单",
        }).then(() => {
          this.$router.push("/");
        });

        return false;
      }

      const subData = { ...this.form, ...dataWithProvinces, ...baseData };

      const result = await this.$api.user.setBaseInfo(subData);

      this.serNo = result.data.serNo;

      window._basic_ = undefined;
      const targetPath = !this.$route.query.upload
        ? `/claimMaterial/uploadFiles/${result.data.serNo}/${this.form.t}`
        : "";

      targetPath && this.$router.push(targetPath);
    },
    async checkUserInfo(insnbr) {
      if (!insnbr) return;
      const result = await this.$api.user.hasUnSubmitUserInfo({ insnbr });

      if (result.data && !Array.isArray(result.data)) {
        await Dialog.alert({
          title: "数据恢复确认",
          message: "该身份证号有未完整提交的理赔信息，\n请继续完成填写",
          theme: "round-button",
        });

        this.fillingData(result.data);
      }
    },
    fillingData(data) {
      this.form = { ...this.form, ...data };
      this.amniocentesisOption.find((item) => {
        if (item.id == data.amniocentesis) this.amniocentesis = item.value;
      });
    },
    async initData() {
      let baseData = {};
      try {
        const strJsonBaseData = window.sessionStorage.getItem("baseData");

        baseData = JSON.parse(strJsonBaseData);

        this.form.name = baseData.name;
        this.form.idStr = baseData.idStr;
        this.checkUserInfo(baseData.insnbr);
      } catch (error) {
        //
      }

      if (!this.$route.query.serNo) {
        this.localData(baseData);
        return;
      }

      const { data } = await this.$api.user.getUserInfo({
        serNo: this.$route.query.serNo,
      });

      if (baseData !== null) {
        if (baseData.name !== data.name || baseData.idStr !== data.idStr) {
          return;
        }
      }

      this.fillingData(data);
    },
    localData(baseData) {
      if (baseData === null) return;
      if (!window._basic_) return;

      try {
        const { form, amniocentesis, areaAllName, serNo } = window._basic_;

        // 数据不一致则不作回显操作
        if (baseData.name !== form.name || baseData.idStr !== form.idStr)
          return;

        this.form = form;
        this.amniocentesis = amniocentesis;
        this.areaAllName = areaAllName;
        this.serNo = serNo;
      } catch (error) {
        return;
      }
    },
  },
  beforeDestroy() {
    const local = {
      form: this.form,
      amniocentesis: this.amniocentesis,
      areaAllName: this.areaAllName,
      serNo: this.serNo,
    };
    const dataWithProvinces = this.$refs.FormWithProvinces.verify();

    if (dataWithProvinces) {
      local.form = { ...local.form, ...dataWithProvinces };
    }

    window._basic_ = local;
  },
};
</script>
<style lang="less">
.basic-container {
  position: relative;
  .outer-ring {
    padding-top: 30px;
    padding-bottom: 120px;
  }
  .title {
    position: absolute;
    font-size: 16px;
    text-align: center;
    top: -10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 180px;
    padding: 0 6px;
    background-color: #fff;
    font-weight: 600;
  }

  .operate {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    .van-button {
      flex: 1;
    }
  }

  .van-cell {
    padding: 10px;
  }

  .van-cell__value {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 1px 8px;
  }

  .popup-container {
    position: relative;
    height: 100%;
  }

  .popup-header {
    width: 100%;
    background-color: #fff;
    z-index: 99;
    position: absolute;
    left: 0;
    right: 20px;
    top: 0;

    .popup-search {
      width: 88%;
    }

    .van-cell__value {
      border: 0;
    }

    .van-cell {
      padding: 4px;
    }
  }

  .popup-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .van-button {
      width: 100%;
    }
  }

  .popup-content {
    height: calc(100% - 100px);
    overflow-y: auto;
    padding: 50px 8px;

    .popup-description-black {
      color: @black;
    }

    .popup-description-orange {
      margin-top: 20px;
      color: @orange-dark;
    }
  }
}

.van-popup {
  .van-popup__close-icon--top-right {
    z-index: 99999;
  }
}
</style>
